import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Heart, Code, BookOpen } from 'lucide-react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';

export const AboutPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-secondary/20 pb-24">
      {/* Header */}
      <header className="sticky top-0 bg-background/80 glass border-b border-border backdrop-blur-lg z-10">
        <div className="max-w-2xl mx-auto px-4 py-4">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate(-1)}
              className="p-2 hover:bg-secondary rounded-full interactive"
            >
              <ArrowLeft className="w-6 h-6" />
            </button>
            <div>
              <h1 className="text-2xl font-bold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Acerca de
              </h1>
              <p className="text-sm text-muted-foreground">Versión 1.0.0</p>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-6">
        {/* App Info */}
        <div className="text-center mb-8">
          <div className="inline-block relative mb-4">
            <div className="w-24 h-24 bg-gradient-to-br from-primary to-accent rounded-3xl flex items-center justify-center shadow-xl">
              <div className="w-16 h-16 bg-primary rounded-lg"></div>
              <div className="w-10 h-10 bg-accent rounded absolute -bottom-2 -right-2"></div>
            </div>
          </div>
          <h2 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Tetris Bíblico
          </h2>
          <p className="text-muted-foreground mb-4">
            Construye tu fe, bloque a bloque
          </p>
          <Badge className="bg-primary text-primary-foreground">v1.0.0</Badge>
        </div>

        {/* Description */}
        <Card className="p-6 mb-6">
          <h3 className="text-xl font-bold mb-3">Sobre la Aplicación</h3>
          <p className="text-muted-foreground leading-relaxed mb-4">
            Tetris Bíblico es una experiencia única que combina la jugabilidad clásica del Tetris con la lectura y meditación de las Sagradas Escrituras.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            Cada línea que completes revelará un versículo bíblico, permitiéndote crecer espiritualmente mientras disfrutas de uno de los juegos más icónicos de todos los tiempos.
          </p>
        </Card>

        {/* Features */}
        <Card className="p-6 mb-6">
          <h3 className="text-xl font-bold mb-4">Características</h3>
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <BookOpen className="w-5 h-5 text-primary mt-0.5" />
              <div>
                <h4 className="font-semibold mb-1">Biblioteca Bíblica Completa</h4>
                <p className="text-sm text-muted-foreground">
                  Accede a libros del Antiguo y Nuevo Testamento con versículos pre-cargados.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 bg-primary rounded mt-0.5"></div>
              <div>
                <h4 className="font-semibold mb-1">Mecánicas Clásicas de Tetris</h4>
                <p className="text-sm text-muted-foreground">
                  Disfruta del juego original con controles precisos y sistema de puntuación.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Heart className="w-5 h-5 text-primary mt-0.5" />
              <div>
                <h4 className="font-semibold mb-1">Colecciona Versículos</h4>
                <p className="text-sm text-muted-foreground">
                  Guarda y revisa todos los versículos que has revelado en tu colección personal.
                </p>
              </div>
            </div>
          </div>
        </Card>

        {/* Tech Stack */}
        <Card className="p-6 mb-6">
          <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
            <Code className="w-5 h-5" />
            Tecnología
          </h3>
          <div className="flex flex-wrap gap-2">
            <Badge variant="secondary">React</Badge>
            <Badge variant="secondary">Tailwind CSS</Badge>
            <Badge variant="secondary">Shadcn UI</Badge>
            <Badge variant="secondary">Web Audio API</Badge>
            <Badge variant="secondary">LocalStorage</Badge>
          </div>
        </Card>

        {/* Credits */}
        <Card className="p-6 bg-gradient-to-br from-primary/10 to-accent/10 border-primary/20">
          <div className="text-center">
            <p className="text-sm text-muted-foreground mb-2">
              Hecho con <Heart className="w-4 h-4 inline text-red-500 fill-red-500" /> para la gloria de Dios
            </p>
            <p className="text-xs text-muted-foreground">
              © 2024 Tetris Bíblico. Todos los derechos reservados.
            </p>
          </div>
        </Card>
      </main>
    </div>
  );
};
